import React, { useState } from 'react'
import { useThankYouNote } from './ThankYouNoteProvider'
import { Button } from '../../lib/ui/button'
import { Input } from '../../lib/ui/input'
import { Label } from '../../lib/ui/label'
import { HeartIcon } from '@heroicons/react/24/outline'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../lib/ui/dialog'
import { useTranslation } from '~/hooks/useTranslation'

const SaveModal = ({ buttonVariant = 'default' }) => {
  const { t } = useTranslation('Editor')
  const [open, setOpen] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const { persistThankYouNote, thankYouNoteName, setThankYouNoteName } =
    useThankYouNote()

  const persist = async () => {
    setIsSaving(true)
    await persistThankYouNote()
    setIsSaving(false)
  }

  const saveButtonKeyDown = async (e) => {
    if (e.key !== 'Enter') return
    await persist()
    setOpen(false)
  }

  const saveClick = async (e) => {
    e?.target && (e.target.disabled = true)
    await persist()
    setOpen(false)
  }

  const saveAndExitClick = async (e) => {
    e.target.disabled = true
    await persist()
    window.location.href = '/interview/follow_up_negotiation'
  }

  return (
    <Dialog
      open={open}
      onOpenChange={() => setOpen(!open)}
      className="rounded-2xl"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button variant={buttonVariant}>
          {t('save')} <HeartIcon className="ml-2 w-6" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className="fix-legacy-hack font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">{t('save_changes')}</h2>
          </DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-4">
          <div className="pb-4">
            <Label htmlFor="thankYouNoteName" className="text-lg">
              {t('thankyou_note_name_label')}
            </Label>
            <Input
              type="text"
              className="w-full"
              name="thankYouNoteName"
              value={thankYouNoteName}
              onChange={(e) => setThankYouNoteName(e.target.value)}
              onKeyDown={saveButtonKeyDown}
              disabled={isSaving}
            />
          </div>
          <div className="flex flex-row justify-start">
            <Button className="inline" onClick={saveClick} disabled={isSaving}>
              {t('save')}
            </Button>
            <Button
              className="ml-4 inline"
              onClick={saveAndExitClick}
              disabled={isSaving}
            >
              {t('save_and_exit')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default SaveModal
